export const WATER_LABELS = {
  mm: "Millimetres (depth)",
  cm: "Centimetres (depth)",
  in: "Inches (depth)",
  inch: "Inches (depth)",
  inches: "Inches (depth)",
  m3: "m³ total for the field",
  L: "Litres total for the field",
};
export const ENERGY_SOURCE_UNITS = {
  Electricity: ["kWh", "GJ"],
  Diesel: ["L", "GJ"],
  Gasoline: ["L", "GJ"],
  "Natural gas": ["m3", "GJ"],
  Propane: ["L", "GJ"],
};
export const ENERGY_UNITS = ["kWh", "L", "m3", "GJ"];
export const WATER_HELP = "Seasonal depth averaged over the whole field, or total water volume for that field. 1 mm over 1 ha = 10 m³.";
export const ENERGY_HELP = "Total for this field and crop year. Litres describe liquid fuel; m³ describes natural gas. Holos currently estimates pumping emissions from water, rather than this measurement.";

const has = value => value !== null && value !== undefined && String(value).trim() !== "";
const validNumber = value => Number.isFinite(Number(value)) && Number(value) >= 0;

export function irrigationErrors(value, { complete = false, acres } = {}) {
  const errors = {};
  if (has(value.waterApplied) && !validNumber(value.waterApplied)) errors.waterApplied = "Use zero or a positive amount.";
  if (has(value.waterUnit) && !WATER_LABELS[value.waterUnit]) errors.waterUnit = "Choose a supported water unit.";
  if (complete && !has(value.waterApplied)) errors.waterApplied = "Enter the seasonal water applied.";
  if (complete && !has(value.waterUnit)) errors.waterUnit = "Choose a water unit.";
  if (has(value.waterApplied) && validNumber(value.waterApplied) && WATER_LABELS[value.waterUnit]) {
    const volume = ["L", "m3"].includes(value.waterUnit);
    if (volume && acres !== undefined && (!validNumber(acres) || Number(acres) <= 0)) errors.waterApplied = "A positive field area is required for water volume.";
    const mm = volume
      ? Number(value.waterApplied) * (value.waterUnit === "m3" ? 1000 : 1) / (Number(acres) * 4046.8564224)
      : Number(value.waterApplied) * ({ mm: 1, cm: 10, in: 25.4, inch: 25.4, inches: 25.4 }[value.waterUnit]);
    if ((!volume || acres !== undefined) && mm > 100000) errors.waterApplied = "Converted water depth must not exceed 100,000 mm.";
  }
  if (has(value.energySource) && !ENERGY_SOURCE_UNITS[value.energySource]) errors.energySource = "Choose a supported energy source.";
  if (has(value.energyUnit) && !ENERGY_UNITS.includes(value.energyUnit)) errors.energyUnit = "Choose a supported energy unit.";
  const allowed = ENERGY_SOURCE_UNITS[value.energySource];
  if (allowed && has(value.energyUnit) && !allowed.includes(value.energyUnit)) errors.energyUnit = `${value.energySource} must use ${allowed.join(" or ")}.`;
  if (has(value.energyUsed) && (!validNumber(value.energyUsed) || Number(value.energyUsed) > 10000000)) errors.energyUsed = "Use an amount from 0 to 10,000,000.";
  if (complete && has(value.energyUsed)) {
    if (!has(value.energySource)) errors.energySource = "Choose the source for the recorded irrigation energy.";
    if (!has(value.energyUnit)) errors.energyUnit = "Choose a unit for the recorded irrigation energy.";
  }
  if (complete && has(value.energyUnit) && !has(value.energyUsed)) errors.energyUsed = "Enter an energy amount, or clear its unit.";
  return errors;
}

export function cropIrrigation(cropYear) {
  return {
    waterApplied: cropYear.irrigation_water_applied,
    waterUnit: cropYear.irrigation_water_unit,
    energySource: cropYear.irrigation_energy_source,
    energyUsed: cropYear.irrigation_energy_used,
    energyUnit: cropYear.irrigation_energy_unit,
  };
}

export function energySourceChange(value, source) {
  // Preserve the number for review, but never relabel it with a guessed unit.
  return { ...value, energySource: source, energyUnit: ENERGY_SOURCE_UNITS[source]?.includes(value.energyUnit) ? value.energyUnit : "" };
}
